import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex align-items-center justify-content-center min-vh-100">
          <div className="text-center" style={{ maxWidth: '500px' }}>
            <div className="mb-4" style={{ fontSize: '4rem' }}>⚠️</div>
            <h2 className="mb-3">Something went wrong</h2>
            <p className="text-muted mb-4">
              An unexpected error occurred. Please try refreshing the page.
            </p>
            <button
              className="btn btn-fd-primary me-2"
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </button>
            <a href="/" className="btn btn-fd-outline">
              Go Home
            </a>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
